module.exports = "https://99designs-start-assets.imgix.net/js/6fce6e85ae419c3c79e25d1ebfafbb63.png";